import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import './User_Management_Sidebar.css'

const User_Management_Sidebar = () => {
  const userManagementNav = [
    { title: "Roles", link: "roles" },
    { title: "User", link: "user" },
  ];

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="Report_Analysis_Sidebar User_Management_Sidebar common_sidemenu">
      <div className="menu_section">
        {userManagementNav?.map((item) => {

          const currentSegment = location.pathname.split("/").pop();

          const isActive = currentSegment === item.link;

          return (
            <button
              className={`menu_header ${isActive ? "active" : ""}`}
              onClick={() => {
                navigate(item?.link);
              }}
            >
              {item?.title}
              <span className="arrow">
                <FontAwesomeIcon icon={faAngleRight} />
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default User_Management_Sidebar;
